/**
 * FileListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileListReq
 */
export interface FileListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 文件列表筛选 */
  filter_preset?: string
  /** 文件类型 */
  type__in?: string[]
  /** 存储键前缀 */
  key_prefix__in?: string[]
  /** 上传用户ID列表 */
  upload_user_id__in?: any
  /** 上传员工ID列表 */
  upload_staff_id__in?: any
  /** 最小文件大小 */
  size__gte?: number
  /** 最大文件大小 */
  size__lte?: number
  /** 文件大小范围 */
  size__range?: string
  /** 文件名包含 */
  name__like?: string
  /** 文件名包含 */
  name__contains?: string
  /** 存储键包含 */
  key__contains?: string
  /** 上传时间距今 */
  uploaded_at__since?: string
  /** 上传时间早于 */
  uploaded_at__before?: string
}

/**
 * FileListReq Schema
 */
export const FileListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    filter_preset: {
      description: '文件列表筛选',
      format: 'cons.FileListFilterPreset',
      type: 'string',
      label: '文件列表筛选',
    },
    type__in: {
      description: '文件类型',
      format: '[]cons.FileType',
      items: {
        format: 'cons.FileType',
        type: 'string',
      },
      type: 'array',
      label: '文件类型',
    },
    key_prefix__in: {
      description: '存储键前缀',
      format: '[]cons.FileKeyPrefix',
      items: {
        format: 'cons.FileKeyPrefix',
        type: 'string',
      },
      type: 'array',
      label: '存储键前缀',
    },
    upload_user_id__in: {
      description: '上传用户ID列表',
      format: '[]string',
      type: 'user',
      label: '上传用户ID列表',
    },
    upload_staff_id__in: {
      description: '上传员工ID列表',
      format: '[]string',
      type: 'staff',
      label: '上传员工ID列表',
    },
    size__gte: {
      description: '最小文件大小',
      format: '*int64',
      type: 'integer',
      label: '最小文件大小',
    },
    size__lte: {
      description: '最大文件大小',
      format: '*int64',
      type: 'integer',
      label: '最大文件大小',
    },
    size__range: {
      description: '文件大小范围',
      format: '*string',
      type: 'string',
      label: '文件大小范围',
    },
    name__like: {
      description: '文件名包含',
      format: 'string',
      type: 'string',
      label: '文件名包含',
    },
    name__contains: {
      description: '文件名包含',
      format: 'string',
      type: 'string',
      label: '文件名包含',
    },
    key__contains: {
      description: '存储键包含',
      format: 'string',
      type: 'string',
      label: '存储键包含',
    },
    uploaded_at__since: {
      description: '上传时间距今',
      format: '*string',
      type: 'string',
      label: '上传时间距今',
    },
    uploaded_at__before: {
      description: '上传时间早于',
      format: '*string',
      type: 'string',
      label: '上传时间早于',
    },
  },
  type: 'object',
}
